import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { UUIDUtil } from '@aperza/util';
import { useReactiveMessage } from '@aperza/ui';
import CatalogCluezDownloadModal from './CatalogCluezDownloadModal';
const CatalogCluezDownloadModalLoader = () => {
    const [catalog, setCatalog] = useState({
        requestId: undefined,
        companyId: undefined,
        catalogId: undefined,
    });
    const { getMessage } = useReactiveMessage('CATALOG_DOWNLOAD_CLUEZ');
    useEffect(() => {
        const subscription = getMessage().subscribe((message) => {
            if (message && message.companyId && message.catalogId) {
                setCatalog({
                    requestId: UUIDUtil.uuid(),
                    companyContractDisplayId: message.companyContractDisplayId,
                    companyId: +message.companyId,
                    catalogId: +message.catalogId,
                    catalogPreview: message.catalogPreview,
                });
            }
        });
        const elements = document.getElementsByClassName('catalogDownloadLink');
        if (elements && elements.length > 0) {
            Array.from(elements).forEach((el) => {
                el.addEventListener('click', (event) => {
                    const source = event.currentTarget;
                    if (source && source.dataset.company_id && source.dataset.catalog_id) {
                        event.preventDefault();
                        setCatalog({
                            requestId: UUIDUtil.uuid(),
                            companyContractDisplayId: parseInt(source.dataset.company_contract_display_id, 10),
                            companyId: parseInt(source.dataset.company_id, 10),
                            catalogId: parseInt(source.dataset.catalog_id, 10),
                        });
                    }
                });
            });
        }
        if (window.aperza) {
            window.aperza.aw.catalogCluezDownloadModalLoader = new Date().getTime();
        }
        return () => {
            subscription?.unsubscribe();
        };
    }, []);
    return (React.createElement(CatalogCluezDownloadModal, { requestId: catalog.requestId, catalogId: catalog.catalogId, companyId: catalog.companyId }));
};
export default CatalogCluezDownloadModalLoader;
const renderCatalogCluezDownloadModal = () => {
    const modalId = 'aperza-catalog-cluez-download-modal';
    const modal = document.getElementById(modalId);
    if (!modal) {
        const aperzaCluezCatalogDownloadModal = document.createElement('div');
        aperzaCluezCatalogDownloadModal.id = modalId;
        document.body.appendChild(aperzaCluezCatalogDownloadModal);
        ReactDOM.render(React.createElement(CatalogCluezDownloadModalLoader, null), aperzaCluezCatalogDownloadModal);
    }
    else {
        console.warn(`Trying to create additional modal: ${modalId}`);
    }
};
export { renderCatalogCluezDownloadModal };
